import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=41f489b6&scoped=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=41f489b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f489b6",
  null
  
)

export default component.exports